import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import KindredLogo from '../../Common/Logos/KindredLogo';

const Container = styled.div`
  color: #fff;
  display: flex;
  align-items: flex-end;
  justify-content: center;

  & > p {
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    padding: 0;
    margin: 0 5px 0 10px;
  }
`;
const PoweredByKindred = () => {
  const { t } = useTranslation();
  return (
    <Container>
      <p>{t('global.poweredBy')}</p>
      <KindredLogo color="#fff" width={100} />
    </Container>
  );
};

export default PoweredByKindred;
